import { branchPillClass } from "@/lib/branches";

export const BranchCell = ({ value }) =>
  value ? (
    <span className={`inline-block whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-semibold ${branchPillClass(value)}`} data-testid="branch-pill">
      {value}
    </span>
  ) : (
    <span className="rounded bg-amber-100 px-1.5 py-0.5 text-[11px] font-bold text-amber-700" data-testid="no-branch-flag">
      No Branch
    </span>
  );
